import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

export const entraSsoService = {
  get,
  storeOrUpdate,
  destroy,
  getProperties,
  test,
};

/**
 * List all corporate-group Entra SSO configurations (system-admin only).
 */
function get() {
  return axios
    .get(apiEndpoint.corporateGroupEntraConfigs, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    });
}

/**
 * Create (no id) or update (with id) a configuration.
 */
function storeOrUpdate(data, id = null) {
  return (id
    ? axios.put(apiEndpointFunction.corporateGroupEntraConfigs(id), data, {
        headers: authHeader(),
      })
    : axios.post(apiEndpoint.corporateGroupEntraConfigs, data, {
        headers: authHeader(),
      })
  ).then((res) => {
    if (res && res.status === 200) {
      return res.data;
    }
    return {};
  });
}

function destroy(id) {
  return axios
    .delete(apiEndpointFunction.corporateGroupEntraConfigs(id), {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    });
}

/**
 * All properties (system-admin endpoint) for the default-property dropdown.
 */
function getProperties() {
  return axios
    .get(apiEndpoint.getAllProperties, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return { properties: [] };
    });
}

/**
 * Run the Microsoft-reachability test for a saved config (returns { ok, checks, message }).
 */
function test(id) {
  return axios
    .post(
      `${apiEndpointFunction.corporateGroupEntraConfigs(id)}/test`,
      {},
      { headers: authHeader() }
    )
    .then((res) => (res && res.status === 200 ? res.data : { ok: false }))
    .catch((err) =>
      err.response ? err.response.data : { ok: false, message: "Request failed." }
    );
}
